import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { withTranslation } from 'react-i18next';

import { config } from 'app/config';
import { user, data } from 'services';
import { api } from 'api';
import { getRacks } from 'services/types';
import { ExportButton, ScrollUpButton, Loader2 } from 'libs/ui';
import { notify, getApiError } from 'libs/common';

let filter;

const reportCustomMethods = {
  promise_pay: 'promise_pay.edit',
  // benefit: 'benefit_check.get_report',
};

export const SortContext = React.createContext({
  setSort: () => {},
  getSortArrow: () => {},
  refreshed: 0,
});

class ControllerCmp extends React.Component {
  working = false;
  timer1 = null;
  constructor(props) {
    super(props);

    this.onElementHeightChangeTimer = null;
    this.initialGettingEntriesTimer = null;
    this.initial = {};

    // select method
    this.subType = props.subType ? props.type : '';
    let method = props.type;
    this.isReport = ['utilization', 'statistics'].indexOf(method) !== -1;
    this.isRoles = ['roles'].indexOf(method) !== -1;
    if (this.isReport) {
      method = 'reports';
    } else if (props.subType) {
      method = 'payment_means';
    }
    this.method = method;

    this.state = {
      racks: [],
      dataIsLoading: false,
      documentHeight: null,
      showScrollUp: false,
      xlsInProcess: false,
      refreshed: false,
      cnt: 0,
      summ: 0,
    };
  }

  componentDidMount() {
    this._mounted = true;

    if (data.getRacks() === null) {
      getRacks(
        this.props.parkingId,
        (items) => {
          data.setRacks(items);
          if (this._mounted) {
            this.setState({ racks: items });
          }
        },
        [],
      );
    }

    this.getInitialEntriesHandler();

    this.setInitialScroll();
    window.addEventListener('scroll', this.onScroll);
    this.updateDocumentHeight();

    this.onElementHeightChange(this.updateDocumentHeight);
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.initialGettingEntriesTimer) {
      clearTimeout(this.initialGettingEntriesTimer);
    }
    if (this.onElementHeightChangeTimer) {
      clearTimeout(this.onElementHeightChangeTimer);
    }
    window.removeEventListener('scroll', this.onScroll);
  }

  /**
   * need for receiving data on scroll
   *
   * @memberof Controller
   */
  onElementHeightChange = (callback) => {
    let lastHeight = this.getDocumentHeight();
    let newHeight = null;

    const run = () => {
      newHeight = this.getDocumentHeight();
      if (lastHeight !== newHeight) {
        if (callback) callback();
        lastHeight = newHeight;
      }

      if (this.onElementHeightChangeTimer) {
        clearTimeout(this.onElementHeightChangeTimer);
      }
      this.onElementHeightChangeTimer = setTimeout(run, 500);
    };
    run();
  };
  updateDocumentHeight = () => {
    const height = this.getDocumentHeight();
    this.setState({ documentHeight: height });
  };

  getDocumentHeight = () => {
    return Math.max(document.body.offsetHeight, document.body.scrollHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight);
  };
  setInitialScroll = () => {
    let scrollPosition = this.props.interface ? this.props.interface.scrollPosition : 0;
    window.scrollTo(0, scrollPosition);
  };
  scrollToUp = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  onScroll = () => {
    if (this.timer1) {
      clearTimeout(this.timer1);
    }
    const scrollOffset = 30;
    const scrollHeight = window.innerHeight + window.scrollY; //pageYOffset

    if (!this.state.showScrollUp && scrollHeight > document.documentElement.clientHeight) {
      this.setState({ showScrollUp: true });
    } else if (this.state.showScrollUp && scrollHeight === document.documentElement.clientHeight) {
      this.setState({ showScrollUp: false });
    }

    if (scrollHeight > this.state.documentHeight - scrollOffset) {
      this.timer1 = setTimeout(() => {
        this.getEntries();
      }, 150);
    }
  };

  getInitialEntriesHandler = () => {
    if (this.props.gridFilter) {
      this.initialGettingEntriesTimer = setTimeout(this.getInitialEntries, 300);
    } else {
      this.getInitialEntries();
    }
  };

  getInitialEntries = () => {
    this.getEntries({ offset: 0 }, undefined, true);
  };

  // methods for sorting
  setSort = (name) => {
    const currentDirection = this.getSortDirection(name);
    const direction = currentDirection ? (currentDirection === 'desc' ? 'asc' : 'desc') : 'asc';

    let params = [
      {
        field_name: name,
        direction: direction,
      },
    ];
    this.props.setSortParams(params);
    this.getEntries({ offset: 0 }, params, true);
  };

  getSortArrow = (name) => {
    const direction = this.getSortDirection(name);
    if (!direction) {
      return null;
    }
    if (direction === 'asc') {
      return <span className="fa fa-long-arrow-up" />;
    } else {
      return <span className="fa fa-long-arrow-down" />;
    }
  };

  getSortDirection(name) {
    let sortParams = this.props.sortParams;
    for (let i = 0; i < sortParams.length; i++) {
      if (sortParams[i].field_name === name) {
        return sortParams[i].direction;
      }
    }
  }

  getFilter = () => {
    if (!this.props.getRequestParams) {
      filter = this.initial;
      return this.initial;
    }
    const reqParams = this.props.getRequestParams(this.props.filter);
    filter = reqParams ? (Object.keys(reqParams).length ? reqParams : this.initial) : this.initial;
    //console.log('🚀 ~ reqParams', reqParams, this.initial);
    return filter;
  };

  /**
   * save list to file
   *
   * @memberof Controller
   */
  getReport = (report_format = 'csv') => {
    if (!this.state.xlsInProcess) {
      this.setState({ xlsInProcess: true }, () => {
        const filterParams = this.props.getRequestParams ? this.props.getRequestParams(this.props.filter) : this.props.filter;
        const sortParams = this.props.sortParams;
        if (this.subType) {
          filterParams.mean_type = this.subType;
        }
        let method = this.method;
        if (method === 'benefit' && filterParams.type === 'check') {
          method = 'benefit_check';
        }

        api
          .call(method + '.get_report', { filter_params: filterParams, sort_params: sortParams, format: report_format })
          .then((data) => {
            if (data) {
              this.setState({ xlsInProcess: false });
              window.open(config.network.xls_url + data, '_blank');
            }
          })
          .catch((error) => {
            const msg = getApiError(error);
            console.log('msg', msg);
            notify(this.props.t('messages.ВНИМАНИЕ!'), msg);
            this.setState({ xlsInProcess: false });
          });
      });
    }
  };

  /**
   * add xls link action
   * @param {*} actions []
   * @returns
   */
  getXlsAction = (actions) => {
    const test = reportCustomMethods[this.method] ?? this.method + '.get_xls';
    // console.log("test", test);
    if (user.haveRight(test)) {
      actions.splice(0, 0, { cmp: <ExportButton key="getxls" getReport={this.getReport} /> });
    }
  };

  /**
   * get entries
   */
  refresh = () => {
    this.getEntries({}, null, true);
  };

  /**
   * get entries with filter
   *
   * @memberof Controller
   */
  getEntries = (paggingParams, sortParams, refresh) => {
    if (this.working) {
      return;
    }

    this.working = true;
    const pageSize = 30;
    const out = {};
    let cnt = this.state.cnt;
    if (refresh) {
      this.setState((state) => {
        return { refreshed: !state.refreshed };
      });
      // console.log('🚀 ~ refresh:', refresh);
      this.props.clearEntries();
      out.cnt = 0;
      cnt = 0;
    }

    out.dataIsLoading = true;
    let newOffset = paggingParams ? paggingParams.offset : this.props.offset;
    let reqSortParams = sortParams ? sortParams : this.props.sortParams;
    //console.log(cnt, )
    if (cnt && newOffset >= cnt) {
      this.working = false;
      return;
    }

    this.setState(out);
    const filter = this.getFilter();
    const method = this.isReport ? this.method + '.' + this.props.type : this.method + '.list';
    if (this.subType) {
      filter.mean_type = this.subType;
    }

    let requestParams = {
      filter_params: filter,
      sort_params: reqSortParams,
      paging_params: {
        limit: pageSize,
        offset: newOffset,
      },
    };
    if (this.isReport) {
      requestParams = filter;
    }

    api
      .call(method, requestParams)
      .then((data) => {
        const out = { dataIsLoading: false };
        if (Array.isArray(data)) {
          // console.log('1');
          this.formatItems(data, newOffset);
        } else if (Array.isArray(data.items)) {
          // console.log('2');
          this.formatItems(data.items, newOffset);
          if (data.count !== null) {
            // console.log('3');
            this.props.setCount(data.count);
            out.cnt = data.count;
            out.count_method = data.count_method;
            out.count_limit = data.count_limit;
          }
          // console.log('🚀 ~ .then ~ data.total:', data.total);
          if (data.total !== undefined && data.total !== null) {
            const total = data.items.length ? (data.total === null ? undefined : data.total) : 0;
            out.summ = total;
            if (this.props.setSumm) {
              this.props.setSumm(total);
            }
          } else {
            if (this.props.setSumm) {
              this.props.setSumm(0);
            }
            out.summ = 0;
          }
        }
        // console.log('🚀 ~ ControllerCmp ~ .then ~ out:', out);
        this.setState(out);
      })
      .catch((data) => {
        if (data) {
          this.props.addEntries({});
        }
        if (this._mounted) {
          this.setState({ dataIsLoading: false, cnt: 0 });
        }
      })
      .finally(() => {
        this.working = false;
      });
  };

  formatItems = (data, newOffset) => {
    let entriesObj = {};
    this.props.setOffset(newOffset + data.length);

    if (this.isReport) {
      entriesObj = data;
    } else {
      data.forEach((item) => {
        // js engine sort object keys if key is number
        // and this is breaks sorting in grids
        // so we conversion id's to string
        if (!isNaN(parseFloat(item.id)) && isFinite(item.id)) {
          const key = `id-${item.id}`;
          entriesObj[key] = item;
        } else {
          entriesObj[item.id] = item;
        }
      });
    }

    this.props.addEntries(entriesObj);

    // set count if reports
    if (this.isReport) {
      this.props.setCount(entriesObj.length);
    }
  };

  /**
   * filter submit
   *
   * @memberof Controller
   */
  submit = () => {
    this.initial = {};
    this.getEntries({ offset: 0 }, null, true);
  };

  /**
   * set initial values in filter comp
   *
   * @memberof Controller
   */
  setInitial = (values) => {
    this.initial = Object.assign({}, values);
  };

  render() {
    const Filter = this.props.gridFilter || null;
    const Grid = this.props.grid;
    const Chart = this.props.chart;
    if (data.getRacks() === null) {
      return null;
    }

    if (this.subType) {
      filter.mean_type = this.subType;
    }
    // console.log('🚀 ~ ControllerCmp ~ render ~ filter:', filter);

    return (
      <>
        {Filter && <Filter setInitial={this.setInitial} onSubmit={this.submit} {...this.props} />}

        <SortContext.Provider value={{ setSort: this.setSort, getSortArrow: this.getSortArrow, refreshed: this.state.refreshed }}>
          {this.props.chart && <Chart entries={this.props.entries} />}
          <Grid
            {...this.props}
            summ={this.state.summ}
            count_limit={this.state.count_limit}
            count_method={this.state.count_method}
            // filter_params={filter}
            refresh={this.refresh}
            getEntries={this.getEntries}
            getXlsAction={this.getXlsAction}
            setSort={this.setSort}
            getSortArrow={this.getSortArrow}
            updateDocumentHeight={this.updateDocumentHeight}
            getFilter={this.getFilter}
          />
          {this.state.dataIsLoading && <Loader2 theme={this.props.theme} />}
          {this.state.showScrollUp && <ScrollUpButton src="/images/scroll_up_arrow.png" onClick={this.scrollToUp} />}
        </SortContext.Provider>
      </>
    );
  }
}

ControllerCmp.defaultProps = {
  subType: '',
};

const mapStateToProps = (state, props) => {
  const filterName = props.filterName || `${props.type}Filter`;
  const filterValues = getFormValues(filterName)(state);
  return {
    filter: filterValues,
  };
};

export const Controller = connect(mapStateToProps)(withTranslation()(ControllerCmp));
